import { Box, Dialog, Grid, List, ListItem, Table, TableBody, TableCell, TableContainer, TableHead, Paper, TableRow } from '@mui/material';
import { pdfDetails, Description, modalFooter } from '../../../mock-data/my-company-invoice-mock-data';
import DownloadIcon from '@mui/icons-material/Download';
import ModalLogo from "../../../assets/setting/mycompany/invoces/modalLogo.png";
import "./Invoice/invoice.scss";
const invoiceViewModal = ({ openPdfModal, closePdfModal, selected }: any) => {

  let tableHead = [

    "Description",
    "Until Cost",
    "Qty / Hr Rate",
    "Amount",
  ];
  return (
    <div >
      <Dialog className='view-invoice-modal' PaperProps={{
        sx: {
          borderRadius: "0px", height: "auto", width: "700px", "& ::-webkit-scrollbar": {
            width: "0px",
          },
        }
      }} maxWidth="md"
        open={openPdfModal} onClose={closePdfModal} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DownloadIcon sx={{
          position: "absolute",
          right: "33px",
          color: "white",
          top: "19px",
        }} className="cursor-pointer" />
        <div id="report">
          <Box className='text-white main-wraper' sx={{ display: "flex", backgroundColor: '#4C0027', justifyContent: 'space-between', padding: 2 }}>
            <p style={{ color: '#fff', fontSize: "12px", fontWeight: "600" }}>Invoice {selected.invoiceNo}</p>
          </Box>
          <Box className="main_section text-white" sx={{ background: "#F78812", color: "white" }}>
            <Grid container sx={{ p: { md: 1, xs: "24px 0" } }}>
              <Grid item sm={4} className="modal-logo">
                <img src={ModalLogo} alt="logo" style={{ height: "68px", width: "196px" }} />
              </Grid>
              <Grid item sm={4} sx={{ justifyContent: "right", fontSize: "12px" }}>
                <><List sx={{ padding: "0px !important" }}>
                  {pdfDetails.headerContact.map((c) => {
                    return (<ListItem key={c} sx={{ display: 'flex', justifyContent: { md: 'flex-end' }, lineHeight: 1 }}>{c}</ListItem>)
                  })}
                </List>
                </>
              </Grid>
              <Grid item sm={4}>
                <><List sx={{ padding: "0px !important", fontSize: "12px" }}>
                  {pdfDetails.headerAddress.map((a) => {
                    return (<ListItem key={a} sx={{ display: 'flex', justifyContent: { md: 'flex-end' }, lineHeight: 1 }}>{a}</ListItem>)
                  })}
                </List></>
              </Grid>
            </Grid>
          </Box>
          <Grid className="modal-table" container sx={{ p: { md: 2, xs: "24px 0" } }}>
            {/* Billed To */}
            <Grid item sm={3}>
              <>
                <List sx={{ padding: "0px !important", borderRight: { md: "1px solid #A0A3BD" }, xs: { border: "none" } }}>
                  <ListItem sx={{ lineHeight: "24px", fontSize: "12px", fontWeight: "500", color: "#6E7191" }}>Billed To</ListItem>
                  {pdfDetails.billedTo.map((bill) => {
                    return (<ListItem key={bill} sx={{ lineHeight: "22px", fontWeight: "500", fontSize: "11px", color: "#14142B" }}>{bill}</ListItem>)
                  })}
                </List>
              </>
            </Grid>


            <Grid item sm={3}>
              <List sx={{ padding: "0px !important", }}>
                <ListItem sx={{ lineHeight: "24px", fontSize: "12px", fontWeight: "500", color: "#6E7191" }}><span className="secondary_text" style={{ fontSize: "16px" }}>Customer</span></ListItem>
                {pdfDetails.Customer.map((inv, i) => {
                  return (<ListItem key={i} sx={{ lineHeight: "22px", fontWeight: "500", fontSize: "11px", color: "#14142B" }}>{inv}</ListItem>)
                })}
              </List>
            </Grid>
            <Grid item sm={3}>
              <List sx={{ padding: "0px !important", borderLeft: { md: "1px solid #A0A3BD" }, xs: { border: "none" } }}>
                <ListItem sx={{ lineHeight: "24px", fontSize: "12px", fontWeight: "500", color: "#6E7191" }}><span className="secondary_text" style={{ fontSize: "16px" }}>Invoice Number</span></ListItem>
                {pdfDetails.invoiceDetails.map((inv, i) => {
                  return (<ListItem key={i} sx={{ lineHeight: "22px", fontSize: "11px", fontWeight: `${inv.fw}`, color: `${inv.color}`, }}>{inv.name}</ListItem>)
                })}
              </List>
            </Grid>
            {/* invoice total amount */}

            <Grid item sm={3}>
              <List sx={{ padding: "0px !important" }}>
                <ListItem sx={{ lineHeight: "24px", fontSize: "12px", fontWeight: "500" }} className="secondary_text">Invoice Total Amount</ListItem>
                {pdfDetails.invoiceTotalAmount.map((selected) => {
                  return (
                    <ListItem sx={{ color: "#F78812" }}><span className="secondary-color fw-700 fs-24 lh-32">{selected}</span></ListItem>
                  )
                })}
              </List>
            </Grid>
          </Grid>
          <Grid className='modal-table-footer' container sx={{ p: { md: 2, xs: "24px 10px" } }}>
            <Grid item xs={12} >
              <Box sx={{ borderTop: "3px solid #F78812" }}></Box>
              <TableContainer component={Paper} sx={{ border: "none" }}>
                <Table sx={{ minWidth: 650, border: "none" }} aria-label="simple table">
                  <TableHead>
                    <TableRow sx={{ border: "none", }}>
                      {tableHead.map(head => <TableCell sx={{ border: "none", color: "#F78812", fontSize: "14px", fontWeight: "600" }} key={head}>{head}</TableCell>)}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Description.map((row: any) => (
                      <TableRow
                        sx={{ borderBottom: "1px solid gray" }}
                        key={row.name}
                      >
                        <TableCell sx={{ border: "none", py: .6 }}><p className='fs-14 fw-500 text-black lh-22'>Advantage - List Price</p> <p className='text-gray'>{row.AdvantagePrice}</p></TableCell>
                        <TableCell sx={{ border: "none", py: .6 }}><p className='fs-14 fw-500 text-black lh-22'>{row.unitCost}</p></TableCell>
                        <TableCell sx={{ border: "none", py: .6 }}><p className='fs-14 fw-500 text-black lh-22'>{row.QtyRate}</p></TableCell>
                        <TableCell sx={{ border: "none", py: .6 }}><p className='fs-14 fw-500 text-black lh-22'>{row.amount}</p></TableCell>

                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid item md={12} display="flex" flexWrap="wrap" mt={4}>
              <Grid item md={5} sm={5} xs={12} sx={{ display: "flex", flexDirection: "column", justifyContent: "end" }}>
                <p className='lh-22 fs-14 pargrapgh fw-600'>Billed To </p>
                <p className="text-black fs-14 fw-600">E. Please pay your invoice by....</p>
              </Grid>
              {modalFooter.map((item: any) => (
                <Grid item md={7} sm={8} xs={12} display="flex" flexDirection="column" flexWrap="wrap" alignItems="end">
                  <p className="fw-700 fs-12 text-black lh-24" ><span className="pargrapgh fw-700 fs-12 ">Subtotal</span>{item.Subtotal}</p>
                  <p className=" fw-700 fs-12 text-black lh-24"><span className="pargrapgh fw-700 fs-12" style={{ marginRight: "10px" }}>Tax</span>{item.Tax}</p>
                  <p className="fw-700 fs-12 text-black lh-24"><span className="pargrapgh fw-700 fs-12">Total</span>{item.Total}</p>
                  <p className="fw-700 fs-12 text-black lh-24"><span className="pargrapgh fw-700 fs-12">Amount Due (USD)</span>{item.AmountDue}</p>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </div>
      </Dialog>
    </div>
  )
}
export default invoiceViewModal